import { Pills } from '../components/Pill';
import { SectionHeader } from '../components/SectionHeader';
import { TerminalWindow } from '../components/TerminalWindow';
import { site, yearsCoding } from '../data/site';
import styles from './Since2001.module.css';

const FILE = 'SEAXDEV.DPR';

function DelphiSample({ year }: { year: number }) {
  const kw = styles.kw;
  return (
    <pre className={styles.code} tabIndex={0}>
      <span className={kw}>program</span> SeaxDev;{'\n'}
      <span className={styles.cm}>{'{ Borland Delphi 6, compiled in 2001 }'}</span>
      {'\n\n'}
      <span className={kw}>uses</span>
      {'\n  SysUtils, Dialogs;\n\n'}
      <span className={kw}>var</span>
      {'\n  Bugs: Integer;\n\n'}
      <span className={kw}>begin</span>
      {'\n  Bugs := '}
      <span className={styles.num}>99</span>;{'\n  '}
      <span className={kw}>while</span> Bugs &gt; <span className={styles.num}>0</span>{' '}
      <span className={kw}>do</span>
      {'\n  '}
      <span className={kw}>begin</span>
      {'\n    FixOne(Bugs);\n    Inc(Bugs, Random('}
      <span className={styles.num}>3</span>
      {')); '}
      <span className={styles.cm}>{`{ still true in ${year} }`}</span>
      {'\n  '}
      <span className={kw}>end</span>;{'\n  ShowMessage('}
      <span className={styles.str}>'It works on my machine.'</span>
      {');\n'}
      <span className={kw}>end</span>.
    </pre>
  );
}

export function Since2001() {
  const years = yearsCoding();
  const year = new Date().getFullYear();

  const pills = [
    `writing code since ${site.experienceSince}`,
    "survived Y2K's hangover",
    'still says "it works on my machine"',
  ];

  const header = (
    <div className={styles.tabsBar}>
      <span className={styles.lang}>delphi</span>
      <span className={styles.file}>{FILE}</span>
    </div>
  );

  return (
    <section id="since" className="band band--alt">
      <div className="container split">
        <div className={styles.left}>
          <SectionHeader
            loose
            prompt="$ git log --reverse | head -1"
            title={`${years} years of commits.`}
          />
          <p className="copy">
            The studio is new. Our team started when Borland Delphi was the cool kid, COBOL was
            already &ldquo;legacy,&rdquo; and &ldquo;the cloud&rdquo; was just the weather.
          </p>
          <p className="copy">
            Some of that code is probably still running in a basement somewhere. We&rsquo;re sorry.
            And a little proud.
          </p>
          <Pills items={pills} aria-label="Highlights" />
        </div>

        <TerminalWindow header={header} className={styles.right} bodyClassName={styles.body}>
          <DelphiSample year={year} />
        </TerminalWindow>
      </div>
    </section>
  );
}
